import React, { useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import { MESSAGE, ROUTE } from '../config'
import { getPublicationsForVehicle, getArticlesWithTags, getContentByTag, sortContentsByTitle } from '../extras/utils'

import { connect } from 'react-redux'
import BrowseGuideLayout from '../components/BrowseGuideLayout'
import ContentList from '../components/ContentList'
import Icon from '../components/Icon'

import '../styles/Topics.scss'

const ArticlesContent = ({ articles, match, baseRoute }) => {
  const items = useMemo(() => {
    const tag = decodeURIComponent(match.params.tag)
    const content = tag ? getContentByTag(tag, articles) : articles

    return sortContentsByTitle(content).map(item => ({
      ...item,
      link: `${baseRoute}${ROUTE.BROWSE}${ROUTE.ARTICLES}/${tag}${ROUTE.CONTENT}/${encodeURIComponent(
        item.resourceKey
      )}`,
      icon: <Icon type='list-topic' />,
    }))
  }, [articles, match, baseRoute])

  return (
    <BrowseGuideLayout match={match} baseRoute={baseRoute}>
      {({ filterBrowseMenuItems, offlineBrowseActive }) => (
        <ContentList
          variant='browse-guide'
          topics={offlineBrowseActive ? filterBrowseMenuItems(items) : items}
          emptyText={MESSAGE.EMPTY_TOPICS}
          baseRoute={match.url}
        />
      )}
    </BrowseGuideLayout>
  )
}

ArticlesContent.propTypes = {
  articles: PropTypes.array,
  match: PropTypes.object.isRequired,
  baseRoute: PropTypes.string,
}

function mapStateToProps({ contents: { publications } }) {
  const pubs = getPublicationsForVehicle(publications.toJS())
  const articles = getArticlesWithTags(pubs)

  return { articles }
}

export default connect(mapStateToProps)(withRouter(ArticlesContent))
